import { render } from "./ModalTerminos.vue?vue&type=template&id=319a87c2"
import script from "./ModalTerminos.vue?vue&type=script&lang=js"
export * from "./ModalTerminos.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__